"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
require("rxjs/add/operator/switchMap");
var MetaCategoryPipe = /** @class */ (function () {
    function MetaCategoryPipe(messageService, currentLanguageProvider) {
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
    }
    MetaCategoryPipe.prototype.transform = function (metaCategory, altValue) {
        var _this = this;
        var observable = this.currentLanguageProvider.getCurrentLanguage();
        return observable.switchMap(function (language) {
            // TODO To be changed after kb new version is released
            if (metaCategory && metaCategory['getDisplayNameMultilingual'] && metaCategory['getDisplayNameMultilingual']()) {
                var multilingualName = metaCategory['getDisplayNameMultilingual']();
                return Observable_1.Observable.of(multilingualName.getValue(language.getId()));
            }
            else if (metaCategory && metaCategory.getDisplayNameMsgId()) {
                return _this.messageService.getMessage(metaCategory.getDisplayNameMsgId());
            }
            else if (altValue) {
                return Observable_1.Observable.of(altValue.getValue(language.getId()));
            }
            return Observable_1.Observable.of(metaCategory.getSystemName() || '');
        });
    };
    MetaCategoryPipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'metacategory',
                    pure: true,
                },] },
    ];
    /** @nocollapse */
    MetaCategoryPipe.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
    ]; };
    return MetaCategoryPipe;
}());
exports.MetaCategoryPipe = MetaCategoryPipe;
//# sourceMappingURL=meta-category.pipe.js.map